import { GridColDef } from '@mui/x-data-grid';
import ILabels from '../../models/Indexes/iLabels';
import ProductReferenceCell from '../cell/ProductReferenceCell';
import ProductAttributeDisplayCell from '../cell/ProductAttributeDisplayCell';
import SalesOrgCell from '../cell/SalesOrgCell';

const Labels = (): GridColDef<ILabels>[] => {
  return [
    {
      field: 'primaryImageWithUrlMed',
      headerName: 'Reference',
      flex: 2,
      renderCell: (params) => <ProductReferenceCell row={params.row} imageUrl={params.value} />,
      sortable: false,
      filterable: false,
    },
    {
      field: 'salesOrgDiv',
      headerName: 'Sales Org',
      flex: 2,
      renderCell: (params) => <SalesOrgCell params={params} />,
    },
    {
      field: 'catalogDisplay',
      headerName: 'Catalog',
      flex: 2,
      renderCell: (params) => (
        <ProductAttributeDisplayCell row={params.row} displayValue={params.value} actualValueKey="catalogActual" />
      ),
    },
    { field: 'productYNumber', headerName: 'Y#', flex: 2 },
    { field: 'type', headerName: 'Type', flex: 1 },
    { field: 'productDescription', headerName: 'Description', flex: 4 },
    {
      field: 'materialDisplay',
      headerName: 'Material',
      flex: 2,
      renderCell: (params) => (
        <ProductAttributeDisplayCell row={params.row} displayValue={params.value} actualValueKey="materialActual" />
      ),
    },
    {
      field: 'colorDisplay',
      headerName: 'Color',
      renderCell: (params) => (
        <ProductAttributeDisplayCell row={params.row} displayValue={params.value} actualValueKey="colorActual" />
      ),
    },
    {
      field: 'sizeDisplay',
      headerName: 'Size',
      renderCell: (params) => (
        <ProductAttributeDisplayCell row={params.row} displayValue={params.value} actualValueKey="sizeActual" />
      ),
    },
    {
      field: 'printerCompatibilityDisplay',
      headerName: 'Printer Compatibility',
      flex: 2,
      renderCell: (params) => (
        <ProductAttributeDisplayCell
          row={params.row}
          displayValue={params.value}
          actualValueKey="printerCompatibilityActual"
        />
      ),
    },
    {
      field: 'wireGaugeRangeDisplay',
      headerName: 'Wire Gauge Range',
      flex: 2,
      renderCell: (params) => (
        <ProductAttributeDisplayCell
          row={params.row}
          displayValue={params.value}
          actualValueKey="wireGaugeRangeActual"
        />
      ),
    },
    {
      field: 'sleeveSizeDisplay',
      headerName: 'Sleeve Size',
      flex: 2,
      renderCell: (params) => (
        <ProductAttributeDisplayCell row={params.row} displayValue={params.value} actualValueKey="sleeveSizeActual" />
      ),
    },
    {
      field: 'wireDiameterRangeDisplay',
      headerName: 'Wire Diameter Range',
      flex: 2,
      renderCell: (params) => (
        <ProductAttributeDisplayCell
          row={params.row}
          displayValue={params.value}
          actualValueKey="wireDiameterRangeActual"
        />
      ),
    },
    {
      field: 'printerLabelApplicationsDisplay',
      headerName: 'Printer and Label Applications',
      flex: 2,
      renderCell: (params) => (
        <ProductAttributeDisplayCell
          row={params.row}
          displayValue={params.value}
          actualValueKey="printerLabelApplicationsActual"
        />
      ),
    },
    {
      field: 'printerSuggRibbonCatridgeDisplay',
      headerName: 'Suggested Ribbon / Cartridge',
      flex: 2,
      renderCell: (params) => (
        <ProductAttributeDisplayCell
          row={params.row}
          displayValue={params.value}
          actualValueKey="printerSuggRibbonCatridgeActual"
        />
      ),
    },
  ];
};

export default Labels;
